import { render, staticRenderFns } from "./ConversionsHistory.vue?vue&type=template&id=9245399e"
import script from "./ConversionsHistory.vue?vue&type=script&lang=js"
export * from "./ConversionsHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports